"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryType = void 0;
var CategoryType;
(function (CategoryType) {
    CategoryType["Category"] = "category";
    CategoryType["BrandCategory"] = "brandCategory";
    CategoryType["VirtualCategory"] = "virtualCategory";
    CategoryType["BrandVirtualCategory"] = "brandVirtualCategory";
    CategoryType["ProductCollection"] = "productCollection";
    CategoryType["OfferCollection"] = "offerCollection";
})(CategoryType = exports.CategoryType || (exports.CategoryType = {}));
